    // initialiser
    const init = () => {
        const tooltipWrappers = document.querySelectorAll('.disclosure');
        tooltipWrappers.forEach(tooltipWrapper => {
            const tooltipClickElem = tooltipWrapper.querySelector('a');
            const tooltip = tooltipWrapper.querySelector('.tooltip');
            tooltipClickElem.addEventListener('click', (e) => {
                e.preventDefault();
                tooltip.classList.toggle('visible');
            })
            tooltipClickElem.addEventListener('mouseover', () => {
                tooltip.classList.add('visibleMouseOver');
            })
            tooltipClickElem.addEventListener('mouseout', () => {
                tooltip.classList.remove('visibleMouseOver');
            })
            document.addEventListener('click', function (e) {
                if (e.target !== tooltipClickElem && e.target !== tooltip) {
                    tooltip.classList.remove('visible');
                }
            });
        })
    }

    function ready(init) {
        if (document.readyState != 'loading') {
            init();
        } else {
            document.addEventListener('DOMContentLoaded', init);
        }
    }
    
    ready(init);